import { render, staticRenderFns } from "./CoursesSelectField.vue?vue&type=template&id=6e16a6b6"
import script from "./CoursesSelectField.vue?vue&type=script&lang=js"
export * from "./CoursesSelectField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports